import { useCallback, useEffect } from "react";

export const useVisibility = (onVisible, onHidden) => {
  const handleVisibility = useCallback(() => {
    if (document.visibilityState === "visible") {
      typeof onVisible === "function" && onVisible();
    } else {
      typeof onHidden === "function" && onHidden();
    }
  }, [onVisible, onHidden]);

  useEffect(() => {
    document.addEventListener(`visibilitychange`, handleVisibility);
    return () => {
      document.removeEventListener(`visibilitychange`, handleVisibility);
    };
  }, [handleVisibility]);
};
